import { render, staticRenderFns } from "./houseItem.vue?vue&type=template&id=22dbd0f8&class=component&"
import script from "./houseItem.vue?vue&type=script&lang=js&"
export * from "./houseItem.vue?vue&type=script&lang=js&"
import style0 from "./houseItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22dbd0f8')) {
      api.createRecord('22dbd0f8', component.options)
    } else {
      api.reload('22dbd0f8', component.options)
    }
    module.hot.accept("./houseItem.vue?vue&type=template&id=22dbd0f8&class=component&", function () {
      api.rerender('22dbd0f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/houseItem.vue"
export default component.exports